'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:auditHistory
 * @description
 * # auditHistory
 * Directive to generate a auditHistory UI element
 */
angular.module('thothApp.directives')
.directive('auditHistory', function() {
  return {
    restrict: 'E',
    templateUrl: 'views/_audit-history.html',
    scope: {
      model: '='
    },
    link: function($scope) {
      $scope.visiblePanelId = null;

      $scope.togglePanel = function(auditId) {
        // Collapse currently visible panel if different from the clicked one
        if ($scope.visiblePanelId !== null && $scope.visiblePanelId !== auditId) {
          var currentElement = $('#audits_' + $scope.visiblePanelId);
          currentElement.parents('.panel').find('.panel-body').slideUp();
          currentElement.addClass('panel-collapsed');
        }

        // Toggle the clicked panel
        if ($scope.visiblePanelId === auditId) {
          $scope.visiblePanelId = null;
        } else {
          $scope.visiblePanelId = auditId;
        }

        var element = $('#audits_' + auditId);
        if (element.hasClass('panel-collapsed')) {
          element.parents('.panel').find('.panel-body').slideDown();
          element.removeClass('panel-collapsed');
        } else {
          element.parents('.panel').find('.panel-body').slideUp();
          element.addClass('panel-collapsed');
        }
      };

      $scope.isPanelVisible = function(auditId) {
        return $scope.visiblePanelId === auditId;
      };

      $scope.format_audit_body = function(audit) {
        var auditBody;
        if(_.isEmpty(audit.changes)) {
          auditBody = '';
        } else {
          auditBody = '<table class=\"table table-hover table-head wrap-value table-fixed\">' +
                              '<thead>' +
                                '<tr>' +
                                  '<td>Atributo</td>' +
                                  '<td>Antigüo</td>' +
                                  '<td>Nuevo</td>' +
                                '</tr>' +
                              '</thead>' +
                              '<tbody>';
        }
        Object.keys(audit.changes).forEach(function (key) {
          var value = audit.changes[key];
          if(value !== null) {
            if(typeof(value) === 'object') {
              auditBody += '<tr>' +
                              '<td class="td-wrap">' + key + '</td>' +
                              '<td class="td-wrap">' + value[0] + '</td>' +
                              '<td class="td-wrap">' + value[1] + '</td>' +
                            '</tr>';
            } else {
              auditBody += '<tr>' +
                              '<td class="td-wrap">' + key + '</td>' +
                              '<td></td>' +
                              '<td class="td-wrap">' + value + '</td>' +
                            '</tr>';
            }
          }
        });
        auditBody += '</tbody></table>';
        return auditBody;
      };
    }
  };
});
